export default "__VITE_ASSET__DhtRrhvu__"